import { DEFAULT_SITE_ID } from '../App/constants/constants';
import {
  CONNECT_ACCESS_TOKEN_KEY,
  CONNECT_ID_TOKEN_KEY,
} from '../hooks/useAuth/utils';
import { SiteConfig } from './SiteConfig';

export function getExpireDate(exp: number) {
  return new Date(exp * 1000).toUTCString();
}

export const getCookieValue = (name: string): string => {
  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return (
    document.cookie
      .match(new RegExp(`(^|;)\\s*${escapedName}\\s*=\\s*([^;]+)`))
      ?.pop() || ''
  );
};

export const createCartUidCookieKey = (
  locale: string,
  siteId: string | undefined
): string => {
  const validSiteId = siteId || DEFAULT_SITE_ID;
  return `${validSiteId}-cart-${locale}`;
};

export const createCartTotalItemsCookieKey = (
  locale: string,
  siteId: string | undefined
): string => {
  const validSiteId = siteId || DEFAULT_SITE_ID;
  return `${validSiteId}-cart-total-items-${locale}`;
};

export const getCookieDomain = (cookieKey: string) => {
  const { cookieDomain, isAigateway } = SiteConfig.getConfig();
  if (
    isAigateway &&
    (cookieKey === CONNECT_ACCESS_TOKEN_KEY ||
      cookieKey === CONNECT_ID_TOKEN_KEY)
  ) {
    return '.subscribe.wiley.com';
  }
  return cookieDomain;
};

export const setCookieItem = (key: string, value: string, exp: number) => {
  const expireDate = `expires=${getExpireDate(exp)};`;
  const cookieDomain = `domain=${getCookieDomain(key)};`;

  document.cookie = `${key}=${value}; ${expireDate} ${cookieDomain} path=/`;
};

export const setCartCookieExpTime = (locale, site, exp) => {
  const cartIdCookieKey = createCartUidCookieKey(locale, site);
  const cartIdCookieValue = getCookieValue(cartIdCookieKey);

  const cartTotalItemsCookieKey = createCartTotalItemsCookieKey(locale, site);
  const cartTotalItemsCookieValue = getCookieValue(cartTotalItemsCookieKey);

  setCookieItem(cartIdCookieKey, cartIdCookieValue, exp);
  setCookieItem(cartTotalItemsCookieKey, cartTotalItemsCookieValue, exp);
};

export const eraseCartCookies = (locale, siteId) => {
  const cartIdCookieKey = createCartUidCookieKey(locale, siteId);
  const cartTotalItemsCookieKey = createCartTotalItemsCookieKey(locale, siteId);
  const cookiesToDelete = [cartIdCookieKey, cartTotalItemsCookieKey];
  cookiesToDelete.forEach((cookie) => eraseCookie(cookie));
};

export const eraseCookie = (name: string) => {
  const { cookieDomain } = SiteConfig.getConfig();
  document.cookie = `${name}=; path=/; domain=${cookieDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const getTargetUrl = (): string => {
  const { siteId } = SiteConfig.getConfig();
  const targetCookie = getCookieValue(`${siteId}-target`);
  return targetCookie || SiteConfig.buildContinueShoppingUrl();
};
